import RegisterDeviceToolBar from "@/components/registrations/create-registration/create-registration-tool-bar.vue";
import TooltipComponent from "@/components/global/tooltip-component.vue";
import GlobalMsgAlert from "@/components/global/global-msg-alert.vue";
import GlobalDetailsPopup from "@/components/global/global-details-popup.vue";
import GlobalCancelPopup from "@/components/global/global-cancel-popup.vue";
import CreateRegistrationPopups from "@/components/registrations/create-registration/msg/create-registration-popups.vue";
import CreateRegistrationForm from "@/components/registrations/create-registration/form/create-registration-form.vue";
import { mapActions } from "vuex";
import pgwyClient from "@/api/pgwyClient";

export default {
  components: {
    RegisterDeviceToolBar,
    TooltipComponent,
    GlobalMsgAlert,
    GlobalDetailsPopup,
    GlobalCancelPopup,
    CreateRegistrationPopups,
    CreateRegistrationForm,
  },
  data() {
    return {
      titles: {
        main: {
          titleText: "Create registration",
        },
        sub: {
          subOne: "Token procedure",
          subTwo: "Registration details",
          subThree: "Registration validity",
        }
      },
      icons: {
        required: "fa-asterisk",
        copy: "fa-light fa-copy",
        done: "fa-light fa-check",
      },
      textCopiedContainer: false,
      attrs: {
        class: "mb-6",
        boilerplate: true,
        elevation: 0,
      },
      loading: true,
      procedureObject: {
        registerProcModel: "",
        proceduresWithProtocol: [],
        procedureLabel: "Select a procedure"
      },
      protocolObject: {
        protocolItems: ["CMP", "SCEP", "EST", "ACME"],
        protocolModel: "",
        protocolExist: false,
        protocolLabel: "FQDN e.g. host.example.com"
      },
      valid: true,
      buttonLoader: false,
      registerCreationElements: {
        validity: {
          status: "Open",
          label: "Status",
          validityType: "1",
          validity_duration: "",
          validity_rule: [
            (v) => (v && v >= 1) || "The number has to be greater than zero",
            (v) =>
              !v ||
              /^[0-9]+$/.test(v) ||
              "the number has to be a natural number",
            (v) => /^\d+$/.test(v) || 'Only natural numbers are allowed',
          ],
          optionOneLabel: "Limited",
          optionTwoLabel: "Always",
          durationLabel: "Validity duration",
        },
        SCEP: {
          textFields: [
            {
              id: "fqdn",
              label: "FQDN e.g. host.example.com",
              tooltip: "Fully qualified domain name",
              model: "",
              rules: [(v) => !!v || "FQDN is required"],
              type: "text",
              required: true,
            },
            {
              id: "password",
              label: "Password",
              tooltip: "The password used to register",
              model: "",
              rules: [(v) => !!v || "Password is required"],
              type: "password",
              required: true,
            },
            {
              id: "serialnumber",
              label: "Serial number",
              tooltip: "The serial number used to register",
              model: "",
              rules: [],
              type: "text",
              required: false,
            },
            {
              id: "email",
              label: "Email address",
              tooltip: "The email address used to register",
              model: "",
              rules: [
                (v) =>
                  !v ||
                  /^\S+@\S+\.\S+$/.test(v) ||
                  "Invalid email address. Please use a valid format e.g. address@example.com",
              ],
              type: "email",
              required: false,
            },
          ],
          ipOptions: {
            ipVersions: [
              { id: 1, name: "IPv4" },
              { id: 2, name: "IPv6" },
            ],
            ipVersionLabel: "Select IP version",
            ipAdressLabel: "IP adress",
            textFieldErr: [],
            versionModel: "",
            ipModel: "",
            ipv4Rules: [
              (v) =>
                !v ||
                /^((25[0-5]|2[0-4][0-9]|[01]?[0-9]{1,2})\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
                  v
                ) ||
                "Invalid IP format. Please use a valid format e.g. 127.0.0.0",
            ],
            ipv6Rules: [
              (v) =>
                !v ||
                /^([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$/.test(v) ||
                "Invalid IP format. Please use a valid format e.g. 3002:0bd6:0000:0000:0000:ee00:0033:6778",
            ],
          },
        },
        EST: {
          textFields: [
            {
              id: "fqdn",
              label: "FQDN e.g. host.example.com",
              tooltip: "Fully qualified domain name",
              model: "",
              rules: [(v) => !!v || "FQDN is required"],
              type: "text",
              required: true,
            },
          ],
          certAuth: [
            {
              id: "subject-commonname",
              label: "Subject common name",
              model: "",
              rules: [(v) => !!v || "Subject common name is required"],
              type: "text",
              required: true,
            },
            {
              id: "authentication-certificate-ca",
              label: "AWB name",
              model: "",
              rules: [],
              type: "text",
              required: false,
            },
          ],
          httpAuth: [
            {
              id: "password",
              label: "Password",
              model: "",
              rules: [],
              type: "registerCreationElements.EST.show ? 'text' : 'password'",
              required: false,
            },
            {
              id: "username",
              label: "Authentication username",
              model: "",
              rules: [(v) => !!v || "Authentictaion username is required"],
              type: "text",
              required: true,
            },
            {
              id: "realm",
              label: "Authentication realm",
              model: "",
              rules: [],
              type: "text",
              required: false,
            },
          ],
          show: false,
          authOptions: {
            authModel: 1,
            authMethods: [
              { id: 1, name: "Certificate based authentication" },
              { id: 2, name: "HTTP basic authentication" },
            ],
            authLabel: "Authentication method"
          },
        },
        CMP: {
          textFields: [
            {
              id: "fqdn",
              label: "FQDN",
              tooltip: "Fully qualified domain name",
              model: "",
              rules: [(v) => !!v || "FQDN is required"],
              type: "text",
              required: true,
            },
            {
              id: "password",
              label: "Password",
              tooltip: "The password used to register",
              model: "",
              rules: [],
              type: "password",
              required: false,
            },
          ],
        },
        ACME: {
          textFields: [
            {
              id: "fqdn",
              label: "FQDN e.g. host.example.com",
              tooltip: "Fully qualified domain name",
              model: "",
              rules: [(v) => !!v || "FQDN is required"],
              type: "text",
              required: true,
            },
            {
              id: "allowedDomains",
              label: "Domain names",
              tooltip: "Domains",
              model: "",
              rules: [],
              type: "text",
              required: false,
            },
          ],
          hmacKeyOptions: {
            hmacKeyModel: "",
            hashHex: "",
            randString: "",
            hmacKeyLabel: "hmacKey"
          },
        },
      },
      created: false,
      done: false,
      showError: false,
      errorMsg: "",
      cancel: false,
    };
  },

  computed: {
    computedRules() {
      const selectModel =
        this.registerCreationElements.SCEP.ipOptions.versionModel;
      if (selectModel === "IPv4") {
        return this.registerCreationElements.SCEP.ipOptions.ipv4Rules;
      } else if (selectModel === "IPv6") {
        return this.registerCreationElements.SCEP.ipOptions.ipv6Rules;
      } else {
        return [];
      }
    },
  },
  watch: {
    "procedureObject.registerProcModel"(newVa, oldVa) {
      this.getProtocol();
    },
    "registerCreationElements.EST.authOptions.authModel"(newVal, oldVal) {
      loggg("change")
      this.estMethodChange();


    }
  },
  methods: {
    ...mapActions(["updateProcedures", "updateRegistrations"]),
    onSelectionChange(selectedItems) { },
    cancelClicked(val) {
      this.cancel = val;
    },
    estMethodChange() {
      const textModel =
        this.registerCreationElements[this.protocolObject.protocolModel];
      textModel.textFields.forEach((field) => {
        field.model = "";
      });
      textModel.certAuth.forEach((field) => {
        field.model = "";
      });
      textModel.httpAuth.forEach((field) => {
        field.model = "";
      });

      this.registerCreationElements.validity.status = "Open";
      this.registerCreationElements.validity.validity_duration = "";
    },
    clearClicked() {
      const textModel =
        this.registerCreationElements[this.protocolObject.protocolModel];
      if (textModel) {
        textModel.textFields.forEach((field) => {
          field.model = "";
        });
        if (this.protocolObject.protocolModel === "EST") {
          textModel.certAuth.forEach((field) => {
            field.model = "";
          });
          textModel.httpAuth.forEach((field) => {
            field.model = "";
          });
        }

        this.procedureObject.registerProcModel = "";
        this.registerCreationElements.validity.status = "Open";
        this.registerCreationElements.validity.validity_duration = "";
        this.registerCreationElements.validity.validityType = "";
        this.protocolObject.protocolExist = false;
        this.protocolObject.protocolModel = "";
        this.registerCreationElements.SCEP.ipOptions.ipModel = "";
        this.$router.push({ name: "Registrations" });
      } else {
        this.$router.push({ name: "Registrations" });
      }
    },
    getProtocol() {
      if (this.procedureObject.registerProcModel !== "") {
        const procedure = this.procedureObject.registerProcModel.protocol;
        this.protocolObject.protocolModel = procedure;
        this.protocolObject.protocolExist = true;
      }
    },
    createRegistration(prop) {
      this.buttonLoader = true;
      this.valid = prop;
      // this.valid = this.$refs.form.validate();
      let procid = this.procedureObject.registerProcModel.procid;
      let protocol = this.protocolObject.protocolModel;
      let params = {
        status: this.registerCreationElements.validity.status,
        validity: this.registerCreationElements.validity.validity_duration,
      };
      if (this.valid) {
        const currentObject =
          this.registerCreationElements[this.protocolObject.protocolModel];

        const specialObject =
          this.registerCreationElements[this.protocolObject.protocolModel];

        if (this.registerCreationElements.validity.validityType === "2") {
          this.registerCreationElements.validity.validity_duration = "always";
        }
        if (this.protocolObject.protocolModel !== "EST") {
          params["hmacKey"] =
            this.registerCreationElements.ACME.hmacKeyOptions.hmacKeyModel;
          params["ipaddress"] =
            this.registerCreationElements.SCEP.ipOptions.ipModel;
        }
        currentObject.textFields.forEach((field) => {
          params[field.id] = field.model;
        });

        if (
          (this.protocolObject.protocolModel === "EST") &
          (this.registerCreationElements.EST.authOptions.authModel === 1)
        ) {
          specialObject.certAuth.forEach((field) => {
            params[field.id] = field.model;
          });
        }
        if (
          (this.protocolObject.protocolModel === "EST") &
          (this.registerCreationElements.EST.authOptions.authModel === 2)
        ) {
          specialObject.httpAuth.forEach((field) => {
            params[field.id] = field.model;
          });
        }
        pgwyClient.createRegistration(procid, protocol, params)
          .then(async () => {
            this.created = true;
            this.buttonLoader = false;
            this.done = true;
            await this.updateRegistrations();
          })
          .catch((err) => {
            this.showError = true;
            this.buttonLoader = false;
            this.done = false;
            this.errorMsg = err.response?.data?.msg || "Please verify the typed fields";
          });
      } else {
        this.buttonLoader = false;
      }
    },
    // Returns 8 random characters
    randomString() {
      this.registerCreationElements.ACME.hmacKeyOptions.randString =
        Math.random().toString(36).slice(2, 10);
    },
    // For acme pre-registration
    // Uses the hmac-sha256 algorithm to encrypt the string
    async hmacSha256Hex(secret, message) {
      const enc = new TextEncoder("utf-8");
      const algorithm = { name: "HMAC", hash: "SHA-256" };
      const key = await crypto.subtle.importKey(
        "raw",
        enc.encode(secret),
        algorithm,
        false,
        ["sign", "verify"]
      );
      const hashBuffer = await crypto.subtle.sign(
        algorithm.name,
        key,
        enc.encode(message)
      );
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      this.registerCreationElements.ACME.hmacKeyOptions.hashHex = hashArray
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
      this.registerCreationElements.ACME.hmacKeyOptions.hmacKeyModel =
        this.registerCreationElements.ACME.hmacKeyOptions.hashHex;
      this.randomString();
      return this.registerCreationElements.ACME.hmacKeyOptions.hashHex;
    },
    copyMaterial() {
      this.textCopiedContainer = true;
      navigator.clipboard.writeText(
        this.registerCreationElements.ACME.hmacKeyOptions.hmacKeyModel
      );
      setTimeout(() => {
        this.textCopiedContainer = false;
      }, 1000);
    },
  },
  mounted() {
    this.updateProcedures().then((procedures) => {
      if (procedures.length) {
        this.procedureObject.proceduresWithProtocol =
          procedures.filter((procedure) => procedure.protocol);
        this.loading = false;
        this.hmacSha256Hex(
          "key",
          this.registerCreationElements.ACME.hmacKeyOptions.randString
        );
      }
    });
    this.randomString();
  },
};
